import React from "react";
import { ArrowUpRight } from "lucide-react";

export default function ProductCard({ product, idx }) {
  const p = product;
  const CTA = p.url ? (
    <a
      href={p.url}
      target="_blank"
      rel="noopener noreferrer"
      className="btn-yellow text-sm py-2.5 px-6"
    >
      Know More
      <ArrowUpRight className="w-4 h-4" />
    </a>
  ) : (
    <button className="btn-yellow text-sm py-2.5 px-6">
      Know More
      <ArrowUpRight className="w-4 h-4" />
    </button>
  );

  return (
    <article
      className="card-soft p-6 sm:p-8 flex flex-col"
      style={{ transform: idx % 2 === 1 ? "translateY(24px)" : "none" }}
    >
      <div
        className="relative aspect-[16/10] rounded-2xl overflow-hidden border-[1.5px] border-[#0F0F10]/80"
        style={{ background: p.accent }}
      >
        <img
          src={p.image}
          alt={p.title}
          className="w-full h-full object-cover"
          loading="lazy"
        />
        <div className="absolute top-3 left-3 font-mono text-xs px-2 py-1 rounded-md bg-[#FFF8E7] border border-[#0F0F10]/40">
          0{p.id}
        </div>
      </div>

      <div className="mt-6 flex flex-wrap gap-2">
        {p.tags.map((t) => (
          <span key={t} className="tag-pill">
            {t}
          </span>
        ))}
      </div>

      <h3 className="mt-5 text-2xl sm:text-3xl font-bold tracking-tight">
        {p.title}
      </h3>
      <p className="mt-3 text-[15px] text-[#0F0F10]/75 leading-relaxed">
        {p.description}
      </p>

      <div className="mt-6 flex items-center justify-between">
        {CTA}
        <div className="font-mono text-xs text-[#0F0F10]/50">
          case-{p.id}
        </div>
      </div>
    </article>
  );
}
